import { forwardRef } from 'react';
import { HlsVideoPlayer, type HlsVideoPlayerProperties } from '../hls-video-player';
import { Image, type ImageProperties } from '../image';

type P = { image: ImageProperties } | HlsVideoPlayerProperties;

const HeaderAsset = forwardRef<HTMLVideoElement, P>((props, ref) => {
  if ('image' in props) {
    const { image } = props;
    return <Image layout="fluid-image" preview={false} {...image} />;
  }

  return <HlsVideoPlayer ref={ref} {...props} />;
});

export default HeaderAsset;
